// extracted by mini-css-extract-plugin
export default {"PanelMenu":"tqiGqZaIlF7NubogWLPb","Button":"gTHTMg6oDJVPLvXQaLHa"};